import { render, staticRenderFns } from "./ClientPropertyDetachDialog.vue?vue&type=template&id=7f7dc584"
import script from "./ClientPropertyDetachDialog.vue?vue&type=script&lang=ts"
export * from "./ClientPropertyDetachDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports